<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">
            {{ isEditMode ? "Edit" : "Create" }} Group{{ isEditMode ? ` - ${group.GroupName}` : "" }}
        </div>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">General</div>
            <div class="panel-body">
                <nz-tabs nzType="card">
                    <nz-tab id="detail-panel" nzTitle="Group Details">
                        <div class="panel-body">
                            <form #frm="ngForm" class="form-horizontal">
                                <div class="form-group">
                                    <label for="groupName" class="col-md-2 control-label">
                                        Group Name
                                        @if (!isEditMode) {
                                            <span style="color: red">*</span>
                                        }
                                    </label>
                                    <div class="col-md-4">
                                        @if (isEditMode) {
                                            <input
                                                id="groupName"
                                                class="form-control"
                                                type="text"
                                                [value]="group.GroupName"
                                                readonly
                                                disabled />
                                        } @else {
                                            <input
                                                name="groupName"
                                                type="text"
                                                required
                                                maxlength="50"
                                                #groupNameMdl="ngModel"
                                                class="form-control"
                                                [(ngModel)]="group.GroupName" />
                                            @if (groupNameMdl.touched && groupNameMdl.invalid) {
                                                <span class="text-danger"> Group Name is required </span>
                                            }
                                        }
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-2 control-label" style="justify-self: left">Roles</div>
                                    <div class="col-md-3 roles-div">
                                        <div>
                                            <div>
                                                <nz-switch
                                                    name="performaAdmin"
                                                    id="performaAdmin"
                                                    nzSize="small"
                                                    [(ngModel)]="group.Permissions.PerFormaAdmin"
                                                    [nzCheckedChildren]="checkedTmpl"
                                                    [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                PerForma Admin
                                            </div>
                                        </div>
                                        @if (moduleIsEnabled("Scan")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="performaScanAdmin"
                                                        id="performaScanAdmin"
                                                        nzSize="small"
                                                        [(ngModel)]="group.Permissions.PerFormaScanAdmin"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    PerForma Scan Admin
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("ARReport")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="arreportUser"
                                                        id="arreportUser"
                                                        nzSize="small"
                                                        [(ngModel)]="group.Permissions.ARReportUser"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    AR Report User
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("FINReport")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="finreportUser"
                                                        id="finreportUser"
                                                        nzSize="small"
                                                        [(ngModel)]="group.Permissions.FINReportUser"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                    FIN Report User
                                                </div>
                                            </div>
                                        }
                                        @if (moduleIsEnabled("APCheck")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="apCheckEnabled"
                                                        id="apCheckEnabled"
                                                        nzSize="small"
                                                        [(ngModel)]="apCheckEnabled"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"
                                                        (ngModelChange)="onApCheckEnabledChange($event)"></nz-switch>
                                                    AP-Check
                                                </div>
                                                @if (apCheckEnabled) {
                                                    <div style="margin: 5px 0px 5px 10px">
                                                        <nz-radio-group nzButtonStyle="solid" nzSize="small">
                                                            <label
                                                                for="apCheckUser"
                                                                name="apCheckUser"
                                                                nz-radio-button
                                                                [(ngModel)]="group.Permissions.APCheckUser"
                                                                (ngModelChange)="
                                                                    group.Permissions.APCheckUser = true;
                                                                    group.Permissions.APCheckAdmin = false
                                                                "
                                                                >User</label
                                                            >
                                                            <label
                                                                for="apCheckAdmin"
                                                                name="apCheckAdmin"
                                                                nz-radio-button
                                                                [(ngModel)]="group.Permissions.APCheckAdmin"
                                                                (ngModelChange)="
                                                                    group.Permissions.APCheckUser = false;
                                                                    group.Permissions.APCheckAdmin = true
                                                                ">
                                                                Admin
                                                            </label>
                                                        </nz-radio-group>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (moduleIsEnabled("PTP")) {
                                            <div>
                                                <div>
                                                    <nz-switch
                                                        name="PTP"
                                                        id="PTP"
                                                        nzSize="small"
                                                        [(ngModel)]="ptpEnabled"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"
                                                        (ngModelChange)="onPTPEnabledChange($event)"></nz-switch>
                                                    Purchase To Pay
                                                </div>
                                                <div style="margin: 5px 0px 5px 10px">
                                                    @if (ptpEnabled) {
                                                        <nz-radio-group nzButtonStyle="solid" nzSize="small">
                                                            <label
                                                                for="ptpStoreManager"
                                                                name="ptpStoreManager"
                                                                nz-radio-button
                                                                [(ngModel)]="group.Permissions.PTPStoreManager"
                                                                (ngModelChange)="
                                                                    group.Permissions.PTPStoreManager = true;
                                                                    group.Permissions.PTPSystemCEO = false
                                                                "
                                                                >Assigned Locations</label
                                                            >
                                                            <label
                                                                for="ptpGlobalAdmin"
                                                                name="ptpGlobalAdmin"
                                                                nz-radio-button
                                                                [(ngModel)]="group.Permissions.PTPSystemCEO"
                                                                (ngModelChange)="
                                                                    group.Permissions.PTPStoreManager = false;
                                                                    group.Permissions.PTPSystemCEO = true
                                                                "
                                                                >Global Admin</label
                                                            >
                                                        </nz-radio-group>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>
                    </nz-tab>
                    @if (isEditMode) {
                        <nz-tab id="user-panel" nzTitle="Users">
                            <div class="panel-body">
                                <nz-table
                                    #userTable
                                    [nzData]="groupUsers"
                                    nzTableLayout="fixed"
                                    emptyText="No users assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of userColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of userTable.data; track data.UserID) {
                                            <tr>
                                                <td>
                                                    {{ data.UserName }}
                                                </td>
                                                <td>
                                                    {{ data.Email }}
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.UserName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeUser(data.UserID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableUsers"
                                        [(ngModel)]="selectedUser"
                                        nzPlaceHolder="Assign user"></nz-select>
                                    <button
                                        nz-tooltip="Assign User"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignUser(selectedUser)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                    }
                    @if (isEditMode) {
                        <nz-tab id="doctype-panel" nzTitle="Document Type Privileges">
                            <div class="panel-body">
                                <nz-table
                                    #privTable
                                    [nzData]="groupDocTypes"
                                    nzTableLayout="fixed"
                                    emptyText="No document type privileges assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of docTypeColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of privTable.data; track data.DocumentTypeID) {
                                            <tr>
                                                <td>{{ data.DocumentTypeName }}</td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.UploadFile"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.EditKeywordData"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.AddNotes"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.DeleteDocuments"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.PerFormaScan"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.DocumentPermissions.DeleteScan"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.DocumentTypeName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeDocType(data.DocumentTypeID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableDocTypes"
                                        [(ngModel)]="selectedDocType"
                                        nzPlaceHolder="Add Document Type"></nz-select>
                                    <button
                                        nz-tooltip="Add Document Type"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="addDocType(selectedDocType)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                    }
                </nz-tabs>
            </div>
        </div>
        @if (isEditMode && moduleIsEnabled("PTP")) {
            <div class="panel panel-default">
                <div class="panel-heading">Purchase To Pay</div>
                <div class="panel-body">
                    <nz-tabs nzType="card">
                        <nz-tab id="location-panel" nzTitle="Locations">
                            <div class="panel-body">
                                <nz-table
                                    #locationTable
                                    [nzData]="groupLocations"
                                    nzTableLayout="fixed"
                                    emptyText="No locations assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of locationColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of locationTable.data; track data.LocationID) {
                                            <tr>
                                                <td>{{ data.LocationName }}</td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.LocationName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeLocation(data.LocationID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableLocations"
                                        [(ngModel)]="selectedLocation"
                                        nzPlaceHolder="Add Location"></nz-select>
                                    <button
                                        nz-tooltip="Add Location"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignLocation(selectedLocation)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab id="department-panel" nzTitle="Departments">
                            <div class="panel-body">
                                <nz-table
                                    #departmentTable
                                    [nzData]="groupDepartments"
                                    nzTableLayout="fixed"
                                    emptyText="No departments assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of departmentColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of departmentTable.data; track data.DepartmentID) {
                                            <tr>
                                                <td>{{ data.DepartmentName }}</td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.DepartmentName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeDepartment(data.DepartmentID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableDepartments"
                                        [(ngModel)]="selectedDepartment"
                                        nzPlaceHolder="Add Department"></nz-select>
                                    <button
                                        nz-tooltip="Add Department"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignDepartment(selectedDepartment)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab id="step-panel" nzTitle="Steps">
                            <div class="panel-body">
                                <nz-table
                                    #stepTable
                                    [nzData]="groupSteps"
                                    nzTableLayout="fixed"
                                    emptyText="No steps assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of stepColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of stepTable.data; track data.StepID) {
                                            <tr>
                                                <td>{{ data.StepName }}</td>
                                                <td>{{ getStepTypeName(data.StepType) }}</td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.IsReadOnly"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.StepName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removeStep(data.StepID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectableSteps"
                                        [(ngModel)]="selectedStep"
                                        nzPlaceHolder="Add Step"></nz-select>
                                    <button
                                        nz-tooltip="Add Step"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignStep(selectedStep)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                        <nz-tab id="ptpForm-panel" nzTitle="Forms">
                            <div class="panel-body">
                                <nz-table
                                    #ptpFormTable
                                    [nzData]="groupPtpForms"
                                    nzTableLayout="fixed"
                                    emptyText="No forms assigned"
                                    nzShowPagination="false"
                                    nzBordered="true"
                                    [nzLoading]="loading">
                                    <thead style="border: 1px solid black">
                                        <tr>
                                            @for (column of ptpFormColumns; track column) {
                                                <th>{{ column.title }}</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (data of ptpFormTable.data; track data.FormID) {
                                            <tr>
                                                <td>{{ data.FormName }}</td>
                                                <td>{{ getPtpFormTypeName(data.FormType) }}</td>
                                                <td style="text-align: center">
                                                    <nz-switch
                                                        nzSize="small"
                                                        [(ngModel)]="data.IsReadOnly"
                                                        [nzCheckedChildren]="checkedTmpl"
                                                        [nzUnCheckedChildren]="uncheckedTmpl"></nz-switch>
                                                </td>
                                                <td style="text-align: center">
                                                    <button
                                                        nz-tooltip="Remove {{ data.FormName }}"
                                                        nz-button
                                                        class="btn btn-default"
                                                        (click)="removePtpForm(data.FormID)">
                                                        <span class="fa-solid fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </nz-table>
                                <div style="display: flex; width: 50%; align-items: center; gap: 8px; margin-top: 8px">
                                    <nz-select
                                        nzShowSearch
                                        nzSelectOnTab
                                        nzAllowClear
                                        [nzShowArrow]="false"
                                        style="width: 100%"
                                        [nzOptions]="selectablePtpForms"
                                        [(ngModel)]="selectedPtpForm"
                                        nzPlaceHolder="Add Form"></nz-select>
                                    <button
                                        nz-tooltip="Add Form"
                                        nz-button
                                        class="btn btn-default"
                                        (click)="assignPtpForm(selectedPtpForm)">
                                        <span style="color: green" class="fa-solid fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </nz-tab>
                    </nz-tabs>
                </div>
            </div>
        }
    </div>
    <button class="btn btn-default" (click)="save(frm)">{{ isEditMode ? "Save" : "Create Group" }}</button>
    @if (isEditMode) {
        <button class="btn btn-default" (click)="reset()" nz-tooltip="Undo all changes since the last successful save">
            Reset
        </button>
    }
    <button class="btn btn-default" (click)="goBack()">{{ isEditMode ? "Back To Groups" : "Cancel" }}</button>
    @if (group.GroupID) {
        <button class="btn btn-danger pull-right" (click)="remove()">Delete Group</button>
    }
</div>
<ng-template #checkedTmpl><nz-icon nzType="check" /></ng-template>
<ng-template #uncheckedTmpl><nz-icon nzType="close" /></ng-template>
